var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-right_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "chevron-right_svg__chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.29 6.71a.996.996 0 0 0 0 1.41L13.17 12l-3.88 3.88a.996.996 0 1 0 1.41 1.41l4.59-4.59a.996.996 0 0 0 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01",
    className: "chevron-right_svg__vector"
  }))));
};
export { SvgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5DaGV2cm9uIFJpZ2h0PC90aXRsZT48ZyBjbGFzcz0iY2hldnJvbi1yaWdodCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNOS4yOSA2LjcxYS45OTYuOTk2IDAgMCAwIDAgMS40MUwxMy4xNyAxMmwtMy44OCAzLjg4YS45OTYuOTk2IDAgMSAwIDEuNDEgMS40MWw0LjU5LTQuNTlhLjk5Ni45OTYgMCAwIDAgMC0xLjQxTDEwLjcgNi43Yy0uMzgtLjM4LTEuMDItLjM4LTEuNDEuMDFaIiBjbGFzcz0idmVjdG9yIi8+PC9nPjwvc3ZnPg==";